import React from "react";
import { GALLERY } from "@/constants/testIds";
import { ImageIcon } from "lucide-react";

// Real OWRS workshop photography (with selected stock as filler — to be replaced as more arrive).
const GALLERY_ITEMS = [
  {
    label: "Porsche 911 3.0 SC (1981) — engine rebuild",
    url: "https://customer-assets.emergentagent.com/job_tesla-performance/artifacts/uhxr9dc7_IMG_0824.jpeg",
    real: true,
  },
  {
    label: "Porsche 981 Boxster — overheating diagnostics & bleed routine",
    url: "https://customer-assets.emergentagent.com/job_tesla-performance/artifacts/utr6f3e9_IMG_0889.jpeg",
    real: true,
  },
  {
    label: "Mini Clubman Cooper S — service & diagnostics",
    url: "https://customer-assets.emergentagent.com/job_tesla-performance/artifacts/6q10zvds_IMG_0707.jpeg",
    real: true,
  },
  {
    label: "Audi R8 — MOT & pre-purchase inspection",
    url: "/assets/audi-r8-mot.jpeg",
    real: true,
  },
  {
    label: "Range Rover Velar — service & inspection",
    url: "https://customer-assets.emergentagent.com/job_tesla-performance/artifacts/9icwqm9a_IMG_2669.jpeg",
    real: true,
  },
  {
    label: "Tesla Model 3 — collected via our trusted EV recovery partners",
    url: "https://customer-assets.emergentagent.com/job_tesla-performance/artifacts/x37fdu98_D77CBD4C-3B4D-4228-A558-195817247BDC_1_105_c.jpeg",
    real: true,
  },
  {
    label: "Nissan Leaf — in for charging port repair",
    url: "https://customer-assets.emergentagent.com/job_tesla-performance/artifacts/r53ncrsk_5F234A37-866E-4866-894F-1D17BE010BF9_1_105_c.jpeg",
    real: true,
  },
  {
    label: "Mercedes A-Class — diagnostics & gearbox software update",
    url: "https://customer-assets.emergentagent.com/job_tesla-performance/artifacts/xgv0kj9x_30ED195C-FDB4-4B44-B21E-18ED45BA10A1_1_105_c.jpeg",
    real: true,
  },
];

export default function Gallery() {
  return (
    <section data-testid={GALLERY.section} className="section">
      <div className="container-owrs">
        <div className="mb-12">
          <div className="overline mb-4">05 — Inside The Workshop</div>
          <h2 className="font-display text-4xl sm:text-5xl font-medium tracking-tighter">
            A glimpse of the work.
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          {GALLERY_ITEMS.map((g, i) => (
            <div
              key={i}
              data-testid={GALLERY.tile(i)}
              className="relative overflow-hidden group aspect-[4/3]"
            >
              <img
                src={g.url}
                alt={g.label}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover opacity-75 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[var(--owrs-bg)] via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 flex items-center gap-2">
                <ImageIcon className="h-3.5 w-3.5 text-[var(--owrs-accent)]" />
                <span className="text-xs tracking-wide text-[var(--owrs-text)]">
                  {g.label}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
